
export const FETCH_NEWSLIST = 'FETCH_NEWSLIST'
export const FETCH_NEWSLIST_SUCCESS = 'FETCH_NEWSLIST_SUCCESS'
export const FETCH_NEWSLIST_FAILURE = 'FETCH_NEWSLIST_FAILURE'

export const fetchNewsList = (search) => ({
    type: FETCH_NEWSLIST,
    payload: search
})

export const fetchNewsListSuccess = (newsList) => ({
    type: FETCH_NEWSLIST_SUCCESS,
    payload: newsList
})

export const fetchNewsListFailed = (message) => ({
    type: FETCH_NEWSLIST_FAILURE,
    payload: message
})
